<template>
    <div>
        <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
            {{ moduleTitle }}
        </ModuleTitleNav>
        <div class="section-line" />
        <fieldset :disabled="formDisabled">
            <b-form-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 134 (b)(4)]
                    </div>
                    <div class="info-text">
                        Describe how the college will offer programs and activities which integrate
                        challenging academic standards aligned with technical instruction.
                    </div>
                    <div class="info-text-emphasis">
                        <b-link :to="{name: 'localApplication.IntegrationOfAcademicsIntoCte'}">
                            See also Local Uses of Funds [Sec 135(b)(4)]
                        </b-link>
                    </div>
                    <b-form-textarea v-model="strengthen" :rows="3" />
                </b-col>
            </b-form-row>
        </fieldset>
        <br>
        <b-form-row>
            <b-col>
                <LocalApplicationModuleActions
                    :is-loading="isSaving"
                    :is-disabled="formDisabled"
                    background-color="#006438"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';

const storeModuleName = 'strengthenAcademicAndTechnicalSkills';
// const storeModuleNamespace = 'localApplications/module';

export default {
    name: 'StrengthenAcademicAndTechnicalSkills',

    props: {
        // formDisabled: { type: Boolean, default: true }
    },

    data() {
        return {
            isSaving: false,
            moduleTitle: 'Strengthen Academic and Technical Skills',
            nextModule: { name: 'localApplication.SpecialPopulations' },
            previousModule: { name: 'localApplication.WibCollaboration' },
        };
    },

    computed: {
        ...mapState('localApplication', {
            currentState: (state) => state.localApplicationData.state.currentState
        }),

        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            localApplicationModuleContent: `localApplication/module/${storeModuleName}/content`
        }),

        formDisabled() {
            return !this.isAuthorized('update', 'local_application', this.currentState);
        },

        strengthen: {
            get() { return this.localApplicationModuleContent.strengthen; },
            set(value) { this.updateContentField({ field: 'strengthen', value }); }
        },
    },

    methods: {
        ...mapActions(`localApplication/module/${storeModuleName}`, {
            saveLocalApplicationModule: 'save',
            updateContentField: 'updateContentField'
        }),

        async saveForm() {
            this.isSaving = true;
            try {
                const response = await this.saveLocalApplicationModule();
                this.isSaving = false;
                Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                this.isSaving = false;
            }
        }
    }
};
</script>
